import { render, staticRenderFns } from "./AccountMailList.vue?vue&type=template&id=3041166a&scoped=true"
import script from "./AccountMailList.vue?vue&type=script&lang=js"
export * from "./AccountMailList.vue?vue&type=script&lang=js"
import style0 from "./AccountMailList.vue?vue&type=style&index=0&id=3041166a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3041166a",
  null
  
)

export default component.exports